import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import tenantPickerMixin from './pickerMixin';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'CoreTenantTermsAndConditions',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [tenantPickerMixin],
  props: {
    termsAndConditions: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      markdownEdit: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['image', 'color', 'inpOutlined', 'inpFilled', 'UiTheme'])), {}, {
    inputTemplateStyle: function inputTemplateStyle() {
      return ['font-family: monospace;', 'font-weight: 500;', 'font-size: 14px;', 'line-height: 1.5em;', 'white-space: pre-wrap;', 'tab-size: 2;', '-webkit-tab-size: 2;', '-moz-tab-size: 2;', '-o-tab-size: 2;;'].join(' ');
    }
  })
};